/**
 * /setup — Setup Center landing page.
 * The former one-shot Property Configuration Wizard has been retired; property
 * setup now happens directly in Master Data. This page is kept as a shortcut
 * hub for super admins jumping into common master-data screens.
 */
import { Link } from "react-router-dom";
import { Building2, BedDouble, Layers, ShieldCheck } from "lucide-react";
import { OperationalCard, PrimaryActionBar } from "@/components/operational";

const CARDS = [
  {
    to:    "/master/hotel-profiles",
    icon:  Building2,
    tint:  "bg-emerald-100 text-emerald-700",
    title: "Hotel Profile",
    desc:  "Edit the property's identity, tax details, contact info and operational limits.",
    testid: "setup-card-hotel-profile",
  },
  {
    to:    "/hotel-settings/services",
    icon:  ShieldCheck,
    tint:  "bg-amber-100 text-amber-700",
    title: "Hotel Services",
    desc:  "Pick which optional services (Restaurant, Bar, Pool, Banquets, Spa …) this property offers.",
    testid: "setup-card-hotel-services",
  },
  {
    to:    "/master/floors",
    icon:  Layers,
    tint:  "bg-sky-100 text-sky-700",
    title: "Floors",
    desc:  "Add or rename the floors of this hotel.",
    testid: "setup-card-floors",
  },
  {
    to:    "/master/room-types",
    icon:  BedDouble,
    tint:  "bg-violet-100 text-violet-700",
    title: "Room Types",
    desc:  "Configure your room categories, occupancy and base rates.",
    testid: "setup-card-room-types",
  },
];

export default function SetupCenter() {
  return (
    <div className="space-y-6 max-w-5xl mx-auto" data-testid="setup-center">
      <PrimaryActionBar
        title="Setup Center"
        subtitle="Quick access to the master-data screens most useful during onboarding."
        actions={[]}
        testid="setup-actionbar"
      />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {CARDS.map((c) => {
          const Icon = c.icon;
          return (
            <Link key={c.to} to={c.to} className="block" data-testid={c.testid}>
              <OperationalCard>
                <div className="flex items-start gap-4">
                  <div className={`w-14 h-14 rounded-xl flex items-center justify-center shrink-0 ${c.tint}`}>
                    <Icon className="w-7 h-7"/>
                  </div>
                  <div>
                    <div className="text-[16px] font-bold mb-1">{c.title}</div>
                    <div className="text-[13px] text-slate-600 leading-snug">{c.desc}</div>
                  </div>
                </div>
              </OperationalCard>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
